// extracted by mini-css-extract-plugin
export default {"sidebar":"SidebarSmall_sidebar__+cz54","sidebarActive":"SidebarSmall_sidebarActive__pTPu+","showArrow":"SidebarSmall_showArrow__gqFP8"};